<template>
  <div class="">
    <van-nav-bar
      title="银行转账"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :fixed="true"
    />
    <div class="title">
      请银行汇款
    </div>
    <div
      class="account"
      v-for="v in $route.params.id"
      :key="v.id"
    >
      <div class="num">账户</div>
      <hr>
      <img
        :src="v.logo"
        alt=""
      />
      <p>户<span class="nbsp"></span>名：<span>{{v.payee}}</span><u
          class="fr"
          @click="copy(v.payee)"
        >复制</u></p>
      <p>开户行：<span>{{v.account_name}}</span><u
          class="fr"
          @click="copy(v.account_name)"
        >复制</u></p>
      <p>账<span class="nbsp"></span>号：<span>{{v.account_card}}</span><u
          class="fr"
          @click="copy(v.account_card)"
        >复制</u></p>
    </div>

    <!-- <div class="title bottom">
      请上传汇款成功凭证 </div>
    <div class="sc">
      <van-uploader
        max-size="113122150"
        accept="image/*"
        @oversize="oversize"
        :after-read="afterRead"
        v-model="fileList"
        max-count="1"
        preview-size="100px"
      />
    
    </div>
  <div class="but">
        <van-button
          type="danger"
          size="large"
          @click="go"
        >确定</van-button>
      </div> -->
  </div>
</template>
<script>
import Vue from 'vue'
import { NavBar, Toast, Uploader, Button } from 'vant'

Vue.use(NavBar).use(Toast).use(Uploader).use(Button)
export default {

  created () {
    // console.log(this.$route.params.id)
  },
  data () {
    return {
      fileList: [],
      yz: "",
      imgfalge: false,
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    copy (text) {
      this.$copyText(text).then(
        function (e) {
          Toast('复制成功')
        },
        function (e) {
          Toast('复制错误,请手动复制')
        }
      )
    },
    go () {
      if (this.imgfalge) {
        Toast('上传成功')
      } else {
        Toast('请先上传凭证')
      }
    },
    oversize () {
      Toast('请上传10m之内的图片')

    },
    afterRead (file) {
      // 此时可以自行将文件上传至服务器
      // console.log(file)
      file.status = 'uploading';
      file.message = '上传中...';

      // setTimeout(() => {
      //   file.status = 'failed';
      //   file.message = '上传失败';
      // }, 1000)

      if (file.file.size > 11312215) {
        file.status = 'failed';
        file.message = '上传失败';
        Toast('请上传10m之内的图片')
        return
      }
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append('image', file.file)
      this.axios.post('uploadCertificate', formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        file.status = 'done';
        this.yz = res.data.path
        this.imgfalge = true

      }).catch(ref => {
        file.status = 'failed';
        file.message = '上传失败';
        console.log(ref)
      })

    },
  },
}
</script>
<style lang="less" scoped>
.title {
  height: 2.3rem;
  background: #4e4e4e;
  color: #ffffff;
  padding: 0.3rem 0;
  font-size: 0.26rem;
  text-align: center;
  padding-top: 1.535rem;
  font-size: 0.373333rem;
}
.account {
  padding: 0.2rem 0.5rem;
  .num {
    font-size: 0.42rem;
    height: 0.8rem;
    line-height: 0.8rem;
  }
  img {
    height: 1.333333rem;
    width: auto;
  }
  p {
    font-size: 0.35rem;
    padding: 0.3rem;
    padding-left: 0.5rem;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .nbsp {
      padding-right: 0.346667rem;
    }
    span {
      font-size: 0.35rem;
      color: #000;
    }
    u {
      font-size: 0.35rem;
    }
  }
}
.bottom {
  height: 1rem;
  line-height: 1rem;
  padding: 0;
}
.sc {
  padding: 0.5rem 1.5rem;
  // text-align: center;
}
.but{
  width: 100%;
  // position: fixed;
  // bottom: 0;
}
</style>
